var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInkFeather(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 217,
    preserveAspectRatio: "xMidYMid",
    viewBox: "0 0 207 217",
    width: 207,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m80.898 166.204v-20.207h10.113v-20.21h-50.564v20.21h10.114v20.207c-30.887 4.041-48.191 19.158-50.564 50.521h132.219c-2.374-31.363-20.432-46.48-51.318-50.521z",
    fill: "#142a3b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m14.47 210.935c-.254 0-.511-.027-.769-.083-1.953-.423-3.19-2.348-2.766-4.299 4.273-19.693 14.773-26.391 30.325-30.812 1.922-.544 3.919.568 4.465 2.488.546 1.921-.568 3.92-2.488 4.467-13.636 3.875-21.696 9.069-25.239 25.39-.367 1.694-1.863 2.849-3.528 2.849z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m47.778 140.225c-.999 0-1.808-.81-1.808-1.807v-5.052c0-.999.809-1.807 1.808-1.807s1.807.808 1.807 1.807v5.052c0 .997-.808 1.807-1.807 1.807z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m80.898 166.204v-20.209h10.113v-20.208h-20.226v20.208h-20.225v10.105c30.886 4.041 59.057 29.262 61.431 60.625h20.225c-2.374-31.363-20.432-46.48-51.318-50.521z",
    fill: "#020403",
    opacity: 0.35
  }), /*#__PURE__*/React.createElement("path", {
    d: "m156.743 38.114v-37.365c-10.113 5.001-26.775 16.016-42.011 31.238-29.618 29.593-44.099 64.359-30.279 78.171 0 0 72.29-72.044 72.29-72.044z",
    fill: "#fbb713"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m103.125 91.686h53.618c-28.319 25.73-59.409 31.418-72.369 18.472 0 0 18.751-18.472 18.751-18.472z",
    fill: "#bb860e"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#142a3b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m68.511 129.803c-.928 0-1.852-.354-2.558-1.061-1.41-1.411-1.41-3.702.003-5.112 0 0 122.758-122.596 122.758-122.596 1.412-1.412 3.699-1.408 5.111.003 1.411 1.412 1.411 3.701-.004 5.112 0 0-122.757 122.597-122.757 122.597-.706.704-1.629 1.057-2.553 1.057z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m171.912 75.092h-48.561c-1.997 0-3.616-1.618-3.616-3.614s1.619-3.615 3.616-3.615h48.561c1.996 0 3.614 1.619 3.614 3.615s-1.618 3.614-3.614 3.614z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m186.619 54.884h-43.149c-1.996 0-3.615-1.617-3.615-3.614 0-1.996 1.619-3.614 3.615-3.614h43.149c1.996 0 3.615 1.618 3.615 3.614 0 1.997-1.619 3.614-3.615 3.614z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m202.431 36.638h-38.093c-1.996 0-3.613-1.618-3.613-3.614s1.617-3.615 3.613-3.615h38.093c1.996 0 3.615 1.619 3.615 3.615s-1.619 3.614-3.615 3.614z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInkFeather);
export default __webpack_public_path__ + "static/media/ink-feather.da5e5e4a8c541582049689b15145d524.svg";
export { ForwardRef as ReactComponent };